import 'aws-sdk/dist/aws-sdk';

export default class AwsService {
    /* @ngInject */
    constructor($q, $window, ManifestService) {
        this.$q = $q;
        this.AWS = $window.AWS;
        this.ManifestService = ManifestService;
    }

    /**
     * Invoke a Lambda function and return the result wrapped in a $q
     * promise
     *
     * @param {String} functionName The name of the lambda function to invoke
     *            as specified in the Cloud Connect API Specification.
     * @param {String|Object} payload The payload to include in the lambda invokation
     */
    invoke(functionName, payload) {
        return this.$q((resolve, reject) => {
            const lambda = new this.AWS.Lambda();
            const p = (payload instanceof String) ? payload : JSON.stringify(payload);
            const params = {
                FunctionName: this.ManifestService.getValue(functionName),
                Payload: p,
            };

            lambda.invoke(params, (err, res) => {
                if (err) {
                    reject(err);
                } else {
                    const resultPayload = JSON.parse(res.Payload);
                    if (resultPayload.errorMessage) {
                        reject(resultPayload.errorMessage);
                    } else {
                        resolve(resultPayload);
                    }
                }
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/services/aws.service.js